"use client";

import * as gtag from "@/helpers/gtag";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

export const Analytics = () => {
  const pathname = usePathname();

  useEffect(() => {
    if (pathname) {
      gtag.pageview(pathname);
    }
  }, [pathname]);

  return null;
};
